import {Observable} from "rxjs/Observable";
import {ajax} from "rxjs/observable/dom/ajax";
import {
    FETCH_CONVERSATIONS_FULLFILLED,
    NEW_CONVERSATION,
    NOTIFY_READ,
    RECEIVED_CONVERSATION_MESSAGE,
    REMOVED_CONVERSATION,
    SESSION_UPDATED,
    UNSUBSCRIBED_SESSION
} from "../reducers/conversations";
import Message from '../components/dialog/message';

const FETCH_CONVERSATIONS = "FETCH_CONVERSATIONS";
const UPDATE_SESSION = "UPDATE_SESSION";

export const FETCH_CONVERSATIONS_REJECTED = "FETCH_CONVERSATIONS_REJECTED";


export const TRIGGER_STOMP_CONNECTION = "TRIGGER_STOMP_CONNECTION";
export const STOMP_CONNECTED = "STOMP_CONNECTED";
export const triggerStompConnection = (dispatch, stomp) => {
    console.log("triggering stomp conneciton");
    return dispatch({
        type: TRIGGER_STOMP_CONNECTION,
        stomp
    })
};
export const connectStomp = action$ => {
    return action$.ofType(TRIGGER_STOMP_CONNECTION)
        .switchMap(action => {
            return Observable.create(observer => {
                action.stomp.connect({}, function () {
                    observer.next({})
                }, function (error) {
                    console.log("Error", error);
                })
            }).map(response => {
                return {
                    type: STOMP_CONNECTED,
                    stomp: action.stomp
                }
            });

            }
        );
};

export const subscribeToDefault = action$ => {
    return action$.ofType(STOMP_CONNECTED)
        .switchMap(action => {
            return Observable.create(observer => {
                action.stomp.subscribe('/topic/sessions', function (message) {
                    observer.next(message);
                })
            })
                    .map(rawMessage => {
                        const message = JSON.parse(rawMessage.body);
                        if (message.type === 'ADDED') {
                            return {
                                type: NEW_CONVERSATION,
                                id: message.sessionId
                            }
                        } else if (message.type === 'REMOVED') {
                            return {
                                type: REMOVED_CONVERSATION,
                                id: message.sessionId
                            }
                        } else {
                            return {
                                type: 'UNKOWN'
                            }
                        }
                    })

            }
        );
};

export const TRIGGER_STOMP_SUBSCRIPTION = "TRIGGER_STOMP_SUBSCRIPTION";
export const triggerStompSubscription = (dispatch, config) => {
    dispatch({
        type: TRIGGER_STOMP_SUBSCRIPTION,
        config
    })
};

export const stompSubscription = action$ => {
    return action$.ofType(TRIGGER_STOMP_SUBSCRIPTION)
        .mergeMap(action => {
            return Observable.create(observer => {
                action.config.stomp.subscribe(action.config.location, (message) => {
                    observer.next(message);
                })
            }).map(rawMessage => {
                console.log("REEEECEIVED", rawMessage);
                const message = JSON.parse(rawMessage.body);
                return {
                    type: RECEIVED_CONVERSATION_MESSAGE,
                    message: new Message(message.content, message.sender !== 'USER', message.sender),
                    id: action.config.conversation
                }


                //return action.config.handler(message);
            });
        });
};


export const triggerConversationsFetch = (dispatch) => dispatch({type: FETCH_CONVERSATIONS});


export const conversationsFetchEpic = action$ => {
    return action$.ofType(FETCH_CONVERSATIONS)
        .switchMap(action => {
            return ajax.getJSON('/api/sessions')
                    .map(response => {
                        return Object.keys(response).reduce((result, session) => {
                            const rawMessages = response[session];
                            result[session] = rawMessages.map(rawMessage => {
                                return new Message(rawMessage.content, rawMessage.sender !== 'USER', rawMessage.sender)
                            });

                            return result;
                        }, {});
                    })
                    .map(conversations => {
                        return {
                            conversations,
                            type: FETCH_CONVERSATIONS_FULLFILLED
                        }
                    })
                    .catch(error => {
                        return Observable.of({
                            type: FETCH_CONVERSATIONS_REJECTED,
                            payload: error.xhr ? error.xhr : error,

                        })
                    })
            }
        );
};

export const unsubscribeSession = (dispatch, subscriptionId, subscription) => {
    if (subscription) {
        subscription.unsubscribe();
    }
    dispatch({
        type: UNSUBSCRIBED_SESSION,
        id: subscriptionId
    });
};

export const notifyRead = (dispatch, conversationId, messageIds) => {
    dispatch({
        type: NOTIFY_READ,
        conversationId,
        messageIds
    })
};

export const triggerBotState = (dispatch, sessionId, enabled) => {
    dispatch({
        type: UPDATE_SESSION,
        sessionId,
        req: {
            botEnabled: enabled
        }
    });
};

export const updateSessionEpic = action$ => {
    return action$.ofType(UPDATE_SESSION)
        .switchMap(action => {
            return ajax.put(`/api/sessions/${action.sessionId}`, action.req, {'Content-Type': 'application/json'})
                    .map(response => {
                        return {
                            sessionId: action.sessionId,
                            type: SESSION_UPDATED,
                            response: response.response
                        }
                    })
                    .catch(error => {
                        return Observable.of({
                            type: FETCH_CONVERSATIONS_REJECTED,
                            payload: error.xhr ? error.xhr : error,

                        })
                    })
            }
        );
};


// WEBPACK FOOTER //
// ./src/epics/conversations.js